import { Expose, Type } from 'class-transformer';
import { Recording } from './recording';
import { TaskStatus } from './task-status';

export class SNVRTask {

    @Expose({ name: 'snvr_task_id' })
    snvrTaskId: number;

    @Expose()
    name: string;

    @Expose({ name: 'side_numbers' })
    sideNumbers: string[];

    @Expose({ name: 'cameras' })
    cameras: string[];

    @Expose({ name: 'order_date' })
    @Type(() => Date)
    orderTime: Date;

    @Expose({ name: 'start_date' })
    @Type(() => Date)
    startTime: Date;

    @Expose({ name: 'end_date' })
    @Type(() => Date)
    endTime: Date;

    @Expose()
    recorders: number[];

    diskSpaceUsage: number;

    downloadedSize: number;

    leftToDownloadSize: number;

    @Expose()
    @Type(() => Recording)
    recordings: Recording[];

    @Expose()
    status: TaskStatus;

}
